import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Menu, Phone, X } from 'lucide-react';
import { navLinks, site } from '../data/site';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${scrolled ? 'bg-navy-900/85 backdrop-blur-xl shadow-[0_10px_40px_-20px_rgba(0,0,0,0.9)]' : 'bg-gradient-to-b from-black/55 to-transparent'}`} data-id="element-246" data-mp="9jrvgupyjrem">
      <nav aria-label="Primary" className={`mx-auto flex max-w-[1400px] items-center justify-between px-5 transition-all duration-500 sm:px-8 ${scrolled ? 'h-16' : 'h-20 md:h-24'}`} data-id="element-247" data-mp="1l1ufu1ld6eq5">
        <a href="#top" className="group flex flex-col leading-none" data-id="element-248" data-mp="jm450p09e5je">
          <span className="font-display text-lg font-semibold tracking-[0.18em] text-white sm:text-xl" data-id="element-249" data-mp="jkt18p6tcxsa">
            UNBELIEVABLE
          </span>
          <span className="mt-1 text-[9px] uppercase tracking-[0.34em] text-brass-light/80" data-id="element-250" data-mp="3n4f6cvpzc5k0">
            Remodeling &amp; Painting
          </span>
        </a>

        <ul className="hidden items-center gap-9 lg:flex" data-id="element-251" data-mp="w5xqb4acggt">
          {navLinks.map(link => <li key={link.label} data-id="element-252" data-mp="5mw1xl0z6d9x">
              <a href={link.href} className="group relative text-[13px] font-medium uppercase tracking-[0.16em] text-white/80 transition-colors hover:text-white" data-id="element-253" data-mp="5nxoomrcso7h">
                {link.label}
                <span className="absolute -bottom-1.5 left-0 h-px w-0 bg-brass transition-all duration-300 group-hover:w-full" data-id="element-254" data-mp="399uy99ng12h8" />
              </a>
            </li>)}
        </ul>

        <div className="flex items-center gap-3" data-id="element-255" data-mp="2wbne3z7355ph">
          <a href={site.phoneHref} className="hidden items-center gap-2 text-[13px] font-medium tracking-wide text-white/85 transition-colors hover:text-brass-light md:flex" data-id="element-256" data-mp="3b1mbhzqtgd3w">
            <Phone className="h-4 w-4" aria-hidden="true" data-id="element-257" data-mp="2ibm51wgo2ryx" />
            {site.phoneDisplay}
          </a>
          <a href="#contact" className="hidden rounded-full bg-brass px-6 py-3 text-[11px] font-bold uppercase tracking-[0.16em] text-navy-900 transition-all duration-300 hover:bg-brass-light hover:shadow-[0_12px_30px_-12px_rgba(192,149,79,0.9)] sm:inline-block" data-id="element-258" data-mp="2de416khib2xs">
            Get a Free Estimate
          </a>
          <button type="button" onClick={() => setOpen(true)} aria-label="Open menu" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white transition-colors hover:bg-white/10 lg:hidden" data-id="element-259" data-mp="7mgukuys4qso">
            <Menu className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="f1sk20cvvtws" />
          </button>
        </div>
      </nav>

      <AnimatePresence data-id="element-261" data-mp="16gq3v6jy7gx">
        {open && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 bg-navy-900/98 backdrop-blur-xl lg:hidden" data-id="element-262" data-mp="54xp1rftkbn9">
            <div className="flex h-20 items-center justify-between px-5 sm:px-8" data-id="element-263" data-mp="k385htiz42fp">
              <span className="font-display text-lg tracking-[0.18em] text-white" data-id="element-264" data-mp="k15g9bpnadc1">
                UNBELIEVABLE
              </span>
              <button type="button" onClick={() => setOpen(false)} aria-label="Close menu" className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-white/20 text-white" data-id="element-265" data-mp="1btmgnhzlr0no">
                <X className="h-5 w-5" aria-hidden="true" data-id="element-266" data-mp="3k33yj9zcuv8f" />
              </button>
            </div>
            <ul className="mt-6 flex flex-col px-5 sm:px-8" data-id="element-267" data-mp="3f3hlb0jj1ezm">
              {navLinks.map((link, i) => <motion.li key={link.label} initial={{
            opacity: 0,
            x: -16
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.06 * i,
            duration: 0.4
          }} className="border-b border-white/10" data-id="element-268" data-mp="3b2fmulxfp6yp" data-mpi={i}>
                  <a href={link.href} onClick={() => setOpen(false)} className="block py-5 font-display text-3xl text-white" data-id="element-269" data-mp="1wplrectorbm">
                    {link.label}
                  </a>
                </motion.li>)}
            </ul>
            <div className="mt-8 space-y-3 px-5 sm:px-8" data-id="element-270" data-mp="plr01i8c6wot">
              <a href="#contact" onClick={() => setOpen(false)} className="block rounded-full bg-brass py-4 text-center text-xs font-bold uppercase tracking-[0.18em] text-navy-900" data-id="element-271" data-mp="289jsd74qj9k3">
                Get a Free Estimate
              </a>
              <a href={site.phoneHref} className="flex items-center justify-center gap-2 rounded-full border border-white/25 py-4 text-xs font-bold uppercase tracking-[0.18em] text-white" data-id="element-272" data-mp="2m9bczqprbo72">
                <Phone className="h-4 w-4" aria-hidden="true" data-id="element-273" data-mp="2w6pkv1xm74nr" />
                {site.phoneDisplay}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}